import InlineLogo from './__generated__/js/inline';
import cssModules from './utils';
import STYLES from './bpk-logo.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
const getClassName = cssModules(STYLES);
const BpkInlineLogo = ({
  className = null,
  ...rest
}) => {
  const classNames = getClassName('bpk-logo', 'bpk-logo__inline', className);
  return /*#__PURE__*/_jsx(InlineLogo, {
    className: classNames,
    ...rest
  });
};
export default BpkInlineLogo;